
import { motion } from 'framer-motion';

const WhatsAppButton = () => {
  return (
    <motion.a
      href="https://wa.me/34629501941"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-40 w-14 h-14 bg-accent-lime rounded-full flex items-center justify-center shadow-[0_4px_20px_rgba(124,255,107,0.4)] hover:scale-110 transition-transform duration-300 cursor-pointer"
      animate={{
        scale: [1, 1.1, 1],
      }}
      transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut',
      }}
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-line text-deep-green text-2xl"></i>
    </motion.a>
  );
};

export default WhatsAppButton;
